/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Start_TitleInputs */

const en_mk_start_title = /** @type {(inputs: Mk_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From nothing to a working team, in one afternoon`)
};

const id_mk_start_title = /** @type {(inputs: Mk_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari nol ke tim yang jalan, dalam satu sore`)
};

/**
* | output |
* | --- |
* | "From nothing to a working team, in one afternoon" |
*
* @param {Mk_Start_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_start_title = /** @type {((inputs?: Mk_Start_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Start_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_start_title(inputs)
	return en_mk_start_title(inputs)
});